<template>
  <g-master name="reportparametertl"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Nombre')" :has-feedback="false">
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Descripción')" :has-feedback="false">
            <a-input
              v-decorator="['description', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown v-bind="fiOptions"
                      endpoint="hierarchy_lookup"
                      :label="$t('Lenguaje')"
                      :formItemConfig="fiOptions"
                      :decorator="['language', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :params="lenguaje">
          </g-dropdown>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['id_report_parameter'],
    computed: {
      parentData () {
        return {
          id_report_parameter: this.id_report_parameter
        }
      }
    },
    data () {
      return {
        lenguaje: {
          h_lookup_type: 'ESP_ENG',
          use_code: true
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'report_parameter_tl',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_report_parameter_tl'
            },
            columns: [
              {title: '#', dataIndex: 'id_report_parameter_tl', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Lenguaje', dataIndex: 'language_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'description'},
            {name: 'language'}
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Report/ReportParameterTl.vue